import showNotification from 'utils/showNotification';
import { logInfo } from 'utils/logging';
import { Api } from 'api/otvety';
import { marusiaApi } from 'api';
import { getCSRFTOKEN } from '../../../utils/cookie/getCSRFToken';

const PostMarusiaVote = async (slug: string): Promise<Api.PostMarusiaVote200Response> => {
  const csrf_token = getCSRFTOKEN('OTVETY-CSRF-TOKEN') || '';
  return await marusiaApi()
    .postMarusiaVote(slug, csrf_token)
    .then((res) => res)
    .catch((error) => {
      showNotification('error', 'Произошла ошибка, повтори попытку позже');
      logInfo(error.toString(), true);
      return { success: false };
    });
};

export default PostMarusiaVote;
